import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import { useMobile } from '../../../../common/services/screenSize/ScreenSizeService';
import { MetroSuburbLinks } from '../../../SearchFooter/SuburbLinks/MetroSuburbLinks';
import { NationwideSuburbLinks } from '../../../SearchFooter/SuburbLinks/NationwideSuburbLinks';
import { NearbySuburbLinks } from '../../../SearchFooter/SuburbLinks/NearbySuburbLinks';
import { StateSuburbLinks } from '../../../SearchFooter/SuburbLinks/StateSuburbLinks';
import { ConditionPresetLinks } from '../../../SearchFooter/preset-links/ConditionPresetLinks';
import { DentalCareInformation } from '../../../SearchFooter/preset-links/DentalCareInformation';
import { SpecialistPresetLinks } from '../../../SearchFooter/preset-links/SpecialistPresetLinks';
import { TreatmentPresetLinks } from '../../../SearchFooter/preset-links/TreatmentPresetLinks';
import {
  ImportantDentalInformation,
  ImportantGPInformation,
} from '../ImportantInformation/ImportantInformation';
import { StyledSidebar, SidebarFilterTitle } from './SidebarFilters.styles';

export const DentalSidebarFilter = () => {
  const [filters] = useSearchFilters();

  const { location } = filters;
  const suburb = location?.suburb;
  const metro = location?.metro;
  const state = location?.state;

  const isMobile = useMobile();

  return (
    <>
      <StyledSidebar>
        {!isMobile && <SidebarFilterTitle>Popular searches</SidebarFilterTitle>}
        {suburb && <NearbySuburbLinks suburb={suburb} filters={filters} isSidebar={true} />}
        {metro && <MetroSuburbLinks metro={metro} filters={filters} isSidebar={true} />}
        {state && <StateSuburbLinks state={state} filters={filters} isSidebar={true} />}
        {!location && <NationwideSuburbLinks filters={filters} isSidebar={true} />}

        <TreatmentPresetLinks filters={filters} isSidebar={true} />
        <ConditionPresetLinks filters={filters} isSidebar={true} />
        <DentalCareInformation filters={filters} isSidebar={true} />
        <SpecialistPresetLinks filters={filters} isSidebar={true} />
      </StyledSidebar>

      <StyledSidebar>
        {!isMobile && <SidebarFilterTitle>Important Information</SidebarFilterTitle>}
        <ImportantDentalInformation />
      </StyledSidebar>
    </>
  );
};

export const GPSidebarFilter = () => {
  const [filters] = useSearchFilters();

  const { location } = filters;
  const suburb = location?.suburb;
  const metro = location?.metro;
  const state = location?.state;

  const isMobile = useMobile();

  return (
    <>
      <StyledSidebar>
        {!isMobile && <SidebarFilterTitle>Popular searches</SidebarFilterTitle>}
        {suburb && <NearbySuburbLinks suburb={suburb} filters={filters} isSidebar={true} />}
        {metro && <MetroSuburbLinks metro={metro} filters={filters} isSidebar={true} />}
        {state && <StateSuburbLinks state={state} filters={filters} isSidebar={true} />}
        {!location && <NationwideSuburbLinks filters={filters} isSidebar={true} />}

        <TreatmentPresetLinks filters={filters} isSidebar={true} />
        <ConditionPresetLinks filters={filters} isSidebar={true} />
        <SpecialistPresetLinks filters={filters} isSidebar={true} />
      </StyledSidebar>

      <StyledSidebar>
        {!isMobile && <SidebarFilterTitle>Important Information</SidebarFilterTitle>}
        <ImportantGPInformation />
      </StyledSidebar>
    </>
  );
};
